import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05c42bd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-bottom":"0.4rem"} }, "Enter a payment amount: ", -1))
const _hoisted_4 = { class: "search-with-button" }
const _hoisted_5 = ["disabled"]

import { ref, computed } from "vue";
import "@vuepic/vue-datepicker/dist/main.css";
import PaymentItem from "@/Interfaces/Payments/FinalSettlementPaymentItem";
import Popup from "./Popup.vue";
import CurrencyInput from "./CurrencyInput.vue";
import { confirmFinalSettlementPayment as confirmPayment } from "@/services/network";
import IConfirmFinalSettlementPaymentRequest from "@/Interfaces/Payments/IConfirmFinalSettlementPaymentRequest";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { authService } from "@/auth/authSingleton";
import {
    MarketCurrency,
    MonetaryValueWithCommas,
    marketSelection,
} from "@/services/helpers/Helper";



export default /*#__PURE__*/_defineComponent({
  __name: 'FinalSettlementPaymentPopUp',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const selectedRow = computed({
    get() {
        return props.modelValue;
    },
    set(val) {
        emits("update:modelValue", val);
    },
});
const working = ref(false);
const paymentAmount = ref<number>();
const amountTotalToSend = ref<number>();
const balanceToSend = ref<number>();
const emits = __emit;

function closeChild() {
    paymentAmount.value = undefined;
    selectedRow.value = undefined;
}

async function ConfirmTransfer() {
    if (working.value) return;
    working.value = true;
    const closeSpinner = useSpinnerPopup().show();
    try {
        if (!selectedRow.value)
            throw new ReferenceError(
                "selectedRow cannot be null when submitting the form"
            );
        if (!paymentAmount.value)
            throw new ReferenceError(
                "paymentAmount cannot be null when submitting the form"
            );
        if (isNaN(parseFloat(selectedRow.value.amountTotal)))
            throw new ReferenceError(
                "amountTotal must be a valid number when submitting the form"
            );
        if (isNaN(parseFloat(selectedRow.value.balance)))
            throw new ReferenceError(
                "balance must be a valid number when submitting the form"
            );
        amountTotalToSend.value = parseFloat(selectedRow.value.amountTotal);
        balanceToSend.value = parseFloat(selectedRow.value.balance);

        const payload : IConfirmFinalSettlementPaymentRequest = (
            {
                invoiceId: selectedRow.value.invoiceId,
                amountTotal: amountTotalToSend.value,
                issueDate: selectedRow.value.issueDate,
                dueDate: selectedRow.value.dueDate,
                balance: balanceToSend.value,
                userEmail: authService.getEmailAddress(),
                market: marketSelection.value,
                amountPaid: paymentAmount.value
            });
        const response = await confirmPayment.put(payload);
        useNotifierWithErrFormatter().success({
            msg: "Payment successfully registered.",
        });
        closeChild();
        emits("confirm");
    } catch (error) {
        useNotifierWithErrFormatter().error({
            name: `${__filename}/${ConfirmTransfer.name}`,
            errorType: "Confirming payment",
            error,
        });
    } finally {
        closeSpinner();
        working.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: !!selectedRow.value,
    "onUpdate:modelValue": closeChild,
    title: "Payment confirmation",
    hasClose: ""
  }, _createSlots({ _: 2 }, [
    (selectedRow.value)
      ? {
          name: "contents",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createTextVNode(" The remaining balance on this final settlement is "),
              _createElementVNode("strong", null, _toDisplayString(_unref(MarketCurrency)[_unref(marketSelection)]) + " " + _toDisplayString(_unref(MonetaryValueWithCommas)(selectedRow.value.balance)), 1)
            ]),
            _createElementVNode("form", {
              class: "top-content",
              onSubmit: _withModifiers(ConfirmTransfer, ["prevent"])
            }, [
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, [
                _createVNode(CurrencyInput, {
                  id: "amount",
                  ref: "amount",
                  modelValue: paymentAmount.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((paymentAmount).value = $event)),
                  class: "invalid-input",
                  currency: _unref(MarketCurrency)[_unref(marketSelection)],
                  max: selectedRow.value.balance,
                  min: 0.01,
                  placeholder: 'Amount',
                  required: ""
                }, null, 8, ["modelValue", "currency", "max"]),
                _createElementVNode("button", {
                  disabled: working.value,
                  class: "right-button"
                }, "Confirm", 8, _hoisted_5)
              ])
            ], 40, _hoisted_2)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue"]))
}
}

})